import { Outlet } from "react-router-dom";
// The shared header — one component for every role, so HR's nav is identical to
// Admin's and Member's. See layout/Header.js.
import Header from "../Header";

const HrLayout = () => {
  return (
    <div className="hr-layout ">
        <Header />
        <div className="hr-body mainOuter">
          <main className="hr-content">
            <Outlet />
          </main>

        </div>
    </div>
  );
};

export default HrLayout;
